<div class="user-image d-flex align-items-center" [ngClass]="wrapperClass">
  <ng-container *ngIf="imageUrl; else defaultImage">
    <img [src]="imageUrl" alt="profile-photo" class="uploaded-image">
  </ng-container>
  <ng-template #defaultImage>
    <div class=" default-img-wrapper d-flex justify-content-center align-items-center">
      <img [src]="defaultimage" alt="default-user">
    </div>
  </ng-template>
  <div class="ms-3 flex-grow-1">
    <button class="btn  fs-14 text-decoration-underline rounded-6 text-secondary-grey" [ngClass]="buttonClass" *ngIf="!imageUrl"
      (click)="triggerUpload(fileInput)" type="button">
      <app-spinner [loader]="loading"></app-spinner>
      <span *ngIf="!loading">Upload {{buttonText}}</span>
    </button>
      <button class="btn text-brand-warning bg-warning-light-10 fs-14  text-decoration-underline rounded-6" *ngIf="imageUrl && !isShowDropDown" (click)="onRemove()">Remove Logo</button>
    <div class="dropdown" *ngIf="imageUrl && isShowDropDown">
      <button class="btn  fs-14 text-decoration-underline rounded-6" [ngClass]="buttonClass" data-bs-toggle="dropdown"
        aria-expanded="false">
        <app-spinner [loader]="loading"></app-spinner>
        <span *ngIf="!loading">
          Update {{buttonText}}
          <svg width="10" height="6" viewBox="0 0 10 6" class="ms-2 rotate align-middle" fill="none">
            <path d="M9 1L5.70707 4.67453C5.31818 5.10849 4.68182 5.10849 4.29293 4.67453L1 1" [attr.stroke]="wrapperClass === 'cover-image' ? '#FFFFFF' : '#565B62'"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </button>
      <ul class="dropdown-menu border-cool-gray rounded-12">
        <li><a class="dropdown-item fs-14 text-secondary-grey" (click)="triggerUpload(fileInput)">Upload {{buttonText}}</a></li>
        <li><a class="dropdown-item fs-14 text-brand-warning" (click)="onRemove()">Remove {{buttonText}}</a></li>
      </ul>
    </div>
    <input type="file" #fileInput accept="image/*" style="display: none" (change)="onFileSelected($event)" />
    <span class="fs-14 text-secondary-grey d-block mt-2" [innerHTML]="helperText"></span>
  </div>
</div>